module.exports = __webpack_public_path__ + "img/search.d7153ed3.svg";